// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import * as OnboardingActions from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import BenchlingCollection from 'BenchlingCollection';
import * as biojs from 'BioJS';
import {Collection as BioJSAnnotations} from 'biojs/Annotation';
import {Sequence} from 'components/Sequence';
// @ts-expect-error
import SequenceAndLibrarySearchView from 'components/SequenceAndLibrarySearchView';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import {Strand} from 'constants/MolbioConstants';
import OnboardingConstants from 'constants/OnboardingConstants';
import {ServerAnnotation} from 'constants/SequenceConstants';
import Annotation from 'molbio/annotations/backbone/Annotation';
import {
  Collection as FeatureLibraryCollection,
  FeatureLibrary,
  FeatureLibraryAttributes,
} from 'molbio/feature-libraries/FeatureLibrary';
import {formatFeatureLibraryName} from 'molbio/feature-libraries/featureLibraryUtil';
import * as sequtil from 'molbio/SeqUtil';
import notifications, {Response} from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import AnnotationTemplate from 'toolbar/annotation-panel/AnnotationTemplate';
import AutoAnnotationModalContent from 'toolbar/annotation-panel/AutoAnnotationModalContent';
import FeatureLibrarySelector from 'toolbar/annotation-panel/FeatureLibrarySelector';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import sortedBy from 'util/sortedBy';
import * as TaskRunner from 'util/TaskRunner';

interface AnnotationMatch {
  name: string;
  annotation_type: string;
  color: string;
  start: number;
  end: number;
  strand: Strand;
  notes: string | null;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const {setTimeout} = window;

interface AutoAnnotateParams {
  type: 'library' | 'sequence' | 'sequence_folder';
  reference_id: string;
}

class AutoAnnotationResults extends Backbone.Collection<Annotation> {
  sequenceID!: string;
  sequence_length!: number;
  annotations!: BioJSAnnotations;
  startIndex!: number;

  static initClass(): void {
    this.prototype.model = Annotation;
  }

  // @ts-expect-error: instance member property vs instance member function mismatch
  url(): string {
    return `/1/api/sequences/${this.sequenceID}/auto-annotations`;
  }

  override initialize(
    models: Array<Annotation>,
    {
      sequenceID,
      // eslint-disable-next-line camelcase
      sequence_length,
      annotations,
      startIndex,
    }: {sequenceID: string; sequence_length: number; annotations: BioJSAnnotations; startIndex: number}
  ): void {
    this.sequenceID = sequenceID;
    // eslint-disable-next-line camelcase
    this.sequence_length = sequence_length;
    this.annotations = annotations;
    this.startIndex = startIndex;
  }

  // @ts-expect-error: instance member property vs instance member function mismatch
  comparator(r1: Annotation, r2: Annotation): number {
    const r1length = sequtil.length(r1.start(), r1.end(), this.sequence_length);
    const r2length = sequtil.length(r2.start(), r2.end(), this.sequence_length);

    if (r1.visible() !== r2.visible()) {
      // @ts-expect-error boolean math actually yields a number so this works fine (e.g. true - false === 1)
      return r2.visible() - r1.visible();
    } else if (r2length !== r1length) {
      return r2length - r1length;
    } else if (r2.start() !== r1.start()) {
      return (
        sequtil.modelToDisplay(r1.start(), this.startIndex) -
        sequtil.modelToDisplay(r2.start(), this.startIndex)
      );
    } else {
      return (
        sequtil.modelEndToDisplay(r1.end(), this.sequence_length, this.startIndex) -
        sequtil.modelEndToDisplay(r2.end(), this.sequence_length, this.startIndex)
      );
    }
  }

  override parse(response: Array<AnnotationMatch>): Array<{_annotation: biojs.Annotation; visible: boolean}> {
    const counts = _.countBy(response, (result) => result.name);
    // eslint-disable-next-line no-restricted-syntax
    return _.map(response, (result) => {
      const model = this.annotations.findWhere({
        name: result.name,
        start: result.start,
        end: result.end,
        strand: result.strand,
      });
      const exists = model != null;
      return {
        _annotation: new biojs.Annotation(result, {parse: true}),
        visible: !exists && counts[result.name] <= 100,
      };
    });
  }

  // @ts-expect-error: types expect JQueryXHR, not JQueryPromise as return type
  fetch(options: {data: AutoAnnotateParams}): JQueryPromise<Array<AnnotationMatch>> {
    return TaskRunner.runTask({
      url: this.url(),
      data: options.data,
    }).done((res) => {
      // @ts-expect-error: this is fine since Backbone takes the POJO attributes and creates Annotation models
      this.set(this.parse(res), {silent: true});
      this.trigger('sync', this);
    });
  }
}

AutoAnnotationResults.initClass();

// @ts-expect-error: we often use Collections instead of Models to power Views
interface AutoAnnotationViewOptions extends Backbone.ViewOptions<FeatureLibraryCollection> {
  sequence: Sequence;
}

// @ts-expect-error: we often use Collections instead of Models to power Views
class AutoAnnotationView extends Backbone.View<FeatureLibraryCollection> {
  autoAnnotationResults!: AutoAnnotationResults;
  selectedFeatureLibraries!: BenchlingCollection<FeatureLibrary, FeatureLibraryAttributes>;
  sequenceSearchView!: SequenceAndLibrarySearchView;
  sequence!: Sequence;
  timeout!: number;

  static initClass(): void {
    this.prototype.events = {
      // @ts-expect-error
      'change .visibility-toggle': 'toggleVisibility',
      'change .global-visibility-toggle': 'toggleAll',
      'click .search-all-libraries-btn': 'searchAll',
    };
  }

  override initialize(options: AutoAnnotationViewOptions): void {
    this.selectSequence = this.selectSequence.bind(this);
    this.selectLibrary = this.selectLibrary.bind(this);
    this.sequenceSearchView = new SequenceAndLibrarySearchView({
      // This actually is bound but we shadow the original method signature.
      // eslint-disable-next-line @typescript-eslint/unbound-method
      selectSequence: this.selectSequence,
      // This actually is bound but we shadow the original method signature.
      // eslint-disable-next-line @typescript-eslint/unbound-method
      selectLibrary: this.selectLibrary,
    });
    this.autoAnnotationResults = new AutoAnnotationResults([], {
      sequenceID: options.sequence.id,
      sequence_length: options.sequence.length(),
      annotations: options.sequence.get('_sequence').annotations(),
      startIndex: options.sequence.startIndex(),
    });
    this.selectedFeatureLibraries = new BenchlingCollection();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.autoAnnotationResults, 'change:visible', this.updateVisible);
    this.listenTo(this.selectedFeatureLibraries, 'add remove reset', () => {
      this.renderFeatureLibraries();
    });
    this.sequence = options.sequence;
  }

  fetchResults(data: AutoAnnotateParams): void {
    this.timeout = setTimeout(() => {
      this.$el.find('.search-throbber').removeClass('hidden');
    }, 100);
    this.autoAnnotationResults
      .fetch({data})
      .done(() => {
        this.updateAnnotationResults(this.autoAnnotationResults);
      })
      .fail((res) => {
        notifications.notifyError(res);
      })
      .always(() => {
        clearTimeout(this.timeout);
        this.$el.find('.search-throbber').addClass('hidden');
      });
  }

  trackChangeSearchCriteria(criteria: 'sequence' | 'folder' | 'feature_library' | 'search_all'): void {
    analytics.track('annotation', 'auto_annotate_search_criteria', {
      product: ANALYTICS_MODULE.MOLBIO,
      polymer_id: this.sequence.id,
      criteria,
    });
  }

  addAnnotationsToSequence(): void {
    analytics.track('annotation', 'add_auto_annotations_click', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.id,
    });
    const toAdd = this.autoAnnotationResults.filter((annotation) => annotation.get('visible'));
    const toAddBiojs = new biojs.AnnotationCollection(
      // eslint-disable-next-line no-restricted-syntax
      _.map(toAdd, (annotation) => annotation.get('_annotation')),
      {sequenceID: this.sequence.id}
    );
    // @ts-expect-error: fileUpdate option is part of custom backbone-extensions
    Backbone.sync('create', toAddBiojs, {fileUpdate: true})
      .done((res: {added: Array<ServerAnnotation>; message: string}) => {
        // eslint-disable-next-line no-restricted-syntax
        const newBiojsAnnotations = _.map(res.added, (d) => new biojs.Annotation(d, {parse: true}));
        // eslint-disable-next-line no-restricted-syntax
        const newAnnotations = _.map(newBiojsAnnotations, (d) => new Annotation({_annotation: d}));
        this.sequence
          .get('_sequence')
          .annotations()
          .batchModify(function (this: BioJSAnnotations) {
            return this.add(newBiojsAnnotations);
          });
        this.sequence.updateVersions();
        notifications.success(res.message);
        OnboardingActions.completeOnboardingTask(
          OnboardingConstants.MODULES.SEQUENCE,
          OnboardingConstants.AUTO_ANNOTATE
        );
        analytics.track('annotation', 'completed_auto_annotate', {
          product: ANALYTICS_MODULE.MOLBIO,
          sequence_id: this.sequence.id,
          annotation_count: newAnnotations.length,
        });
      })
      .fail((res: Response) => {
        notifications.notifyError(res);
        analytics.track('annotation', 'auto_annotate_fail', {
          product: ANALYTICS_MODULE.MOLBIO,
          sequence_id: this.sequence.id,
          error: notifications.getFriendlyError(res),
        });
      });
  }

  toggleAll(e: JQueryEventObject): void {
    const visible = $(e.currentTarget).prop('checked');
    this.autoAnnotationResults.each((annotation) => annotation.set({visible}));
    this.$el.find('.visibility-toggle').prop('checked', visible);
  }

  toggleVisibility(e: JQueryEventObject): void {
    const cid = $(e.target).val();
    const annotation = this.autoAnnotationResults.get(cid);
    annotation.set('visible', (e.target as HTMLInputElement).checked);
  }

  updateAnnotationResults(annotationResults: AutoAnnotationResults): void {
    this.$el.find('.annotation-results').removeClass('hidden');
    if (annotationResults.length > 0) {
      const $els = annotationResults.map((annotation) =>
        $('<tr>').append(
          // eslint-disable-next-line new-cap
          AnnotationTemplate({
            annotation,
            sequence: this.sequence,
            sequtil,
          })
        )
      );
      this.$el.find('.annotation-results .table').removeClass('hidden');
      this.$el.closest('.modal-content').find('.modal-footer .button').removeClass('disabled');
      this.$el.find('.annotation-results .summary')
        .text(`${annotationResults.length} matching features found. \
Select the features you'd like to add to the sequence.`);
      // @ts-expect-error: we sometimes use JQuery for html
      this.$el.find('.annotation-results tbody').html($els);
      this.$el.find('.annotation-results .summary').attr('data-test-component', 'AutoAnnotationView');
      this.$el.find('.annotation-results .summary').attr('data-test-element', 'summaryMessage');
    } else {
      this.$el.find('.annotation-results .table').addClass('hidden');
      this.$el.closest('.modal-content').find('.modal-footer .button').addClass('disabled');
      this.$el.find('.annotation-results .summary').text('No matching features were found.');
    }
  }

  selectSequence(sequence: biojs.Sequence): void {
    this.trackChangeSearchCriteria('sequence');
    this.sequenceSearchView.setInputValue(sequence.get('name'));
    this.selectedFeatureLibraries.reset([]);
    this.fetchResults({type: 'sequence', reference_id: sequence.id});
  }

  // Library is a Backbone Model of a minimal folder.
  selectLibrary(library: Backbone.Model): void {
    this.trackChangeSearchCriteria('folder');
    this.sequenceSearchView.setInputValue(library.get('name'));
    this.selectedFeatureLibraries.reset([]);
    this.fetchResults({type: 'sequence_folder', reference_id: library.get('api_identifier')});
  }

  addFeatureLibrary(featureLibraryId: string): void {
    this.selectedFeatureLibraries.add(this.model.get(featureLibraryId));
    this.selectFeatureLibraries();
  }

  removeFeatureLibrary(featureLibraryId: string): void {
    this.selectedFeatureLibraries.remove(featureLibraryId);
    this.selectFeatureLibraries();
  }

  selectFeatureLibraries(): void {
    if (this.selectedFeatureLibraries.length > 0) {
      this.trackChangeSearchCriteria('feature_library');
      this.sequenceSearchView.clearSearch();
      this.fetchResults({
        type: 'library',
        reference_id: this.selectedFeatureLibraries.map((library) => library.id).join(','),
      });
    } else {
      this.autoAnnotationResults.reset([]);
      this.$el.find('.annotation-results').addClass('hidden');
    }
  }

  searchAll(): void {
    this.trackChangeSearchCriteria('search_all');
    this.selectedFeatureLibraries.reset(this.model.toArray());
    this.fetchResults({type: 'library', reference_id: 'ALL'});
  }

  updateVisible(e: JQueryEventObject): void {
    const every = this.autoAnnotationResults.every((annotation) => annotation.get('visible'));
    const some = this.autoAnnotationResults.some((annotation) => annotation.get('visible'));
    this.$el.find('.global-visibility-toggle').prop({
      checked: some,
      indeterminate: !every && some,
    });
  }

  renderFeatureLibrarySpinner(): void {
    renderToDOM(<HorizontalThrobber />, this.$('.feature-library')[0]);
  }

  renderFeatureLibraries(): void {
    const optionDatas = this.model.map((featureLibrary) => ({
      value: featureLibrary.id,
      name: formatFeatureLibraryName(featureLibrary.toJSON()),
    }));
    const sortedOptionDatas = sortedBy(optionDatas, [(optionDatum) => optionDatum.name]);
    renderToDOM(
      <FeatureLibrarySelector
        onRemove={(featureLibraryId) => {
          this.removeFeatureLibrary(featureLibraryId);
        }}
        onSelect={(featureLibraryId) => {
          this.addFeatureLibrary(featureLibraryId);
        }}
        optionDatas={sortedOptionDatas}
        selectedValues={this.selectedFeatureLibraries.toArray().map((featureLibrary) => featureLibrary.id)}
      />,
      this.$('.feature-library')[0]
    );
  }

  override render(): this {
    renderToDOM(
      <AutoAnnotationModalContent
        onMount={() => {
          this.sequenceSearchView.setElement(this.$('.sequence-search'));
          this.sequenceSearchView.render();
          this.renderFeatureLibrarySpinner();
          this.model.fetch().done(() => {
            this.renderFeatureLibraries();
          });
        }}
      />,
      this.$el[0]
    );
    return this;
  }
}

AutoAnnotationView.initClass();

export default AutoAnnotationView;
